import { Button, Stack } from '@chakra-ui/react'
import { useFormik } from 'formik';
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup';
import CustomInput from '../../form-components/CustomInput';
import { UseApi } from '../../../libraries/UseApi';
import { UserInfoContext } from '../../../provider/UserInfoProvider';

export default function ResetPasswordForm() {
    const { postApi } = UseApi();

    const navigate = useNavigate();

    const { token } = useContext(UserInfoContext);

    const formik = useFormik({
        initialValues: {
            password: '',
            confirm_password: ''
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .required('Password is required')
                .min(8, 'Password must be at least 8 characters')
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/,
                    'Password must contain uppercase, lowercase, number, and special character'
                ),
            confirm_password: Yup.string()
                .required('Confirm Password is required')
                .oneOf([Yup.ref('password')], 'Passwords must match'),
        }),
        onSubmit: (values) => {
            postApi(
                `${process.env.REACT_APP_API_URL}/user/reset-password`, values, { token: token },
                (response) => {
                    // レスポンスチェック
                    if (response.isSuccess === false) {
                        // 入力内容を確認してください。
                        //alert(Message.Common.CONFIRM_INPUT);
                        return;
                    }
                    handleResponse(response);
                    // ワンタイムパスワード切替
                    //setAdminLoginMode(EnumScreenMode.COMPLATE);
                }
            );
        }
    });

    const handleResponse = (response) => {
        navigate('/user-dashboard');
        // if (user.is_first_login === constant.IS_FIRST_LOGIN) {
        //     navigate('/change-default-password');
        // } else if (user.user_type === constant.USER_TYPE_ADMIN) {
        //     navigate('/admin-dashboard');
        // } else if (user.user_type === constant.USER_TYPE_USER || user.user_type === constant.USER_TYPE_EMPLOYEE) {
        //     navigate('/user-dashboard');
        // } else {
        //     navigate('/test');
        // }
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Stack spacing={4}>
                <CustomInput
                    formik={formik}
                    label={'パスワード'}
                    type={'password'}
                    name={'password'}
                    id={'password'}
                    placeholder={'パスワードを入力'}
                    required={true}
                />
                <CustomInput
                    formik={formik}
                    label={'パスワード確認'}
                    type={'password'}
                    name={'confirm_password'}
                    id={'confirm_password'}
                    placeholder={'パスワードを確認する'}
                    required={true}
                />
                <Stack spacing={10}>
                    <Button
                        bg={'orange.400'}
                        color={'white'}
                        _hover={{
                            bg: 'orange.500',
                        }}
                        type='submit'
                    >
                        パスワードをリセット
                    </Button>
                </Stack>
            </Stack>
        </form>
    )
}
